// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2PaVH","title":"ClientInsurance_title__1h6R9","itemText":"ClientInsurance_itemText__HeHBV"};